module.exports = {
  localeName: 'es-AR'
};
